export default __webpack_public_path__ + "static/media/SmartBandhan_hand_left.0cea51a4.png";